import classNames from 'classnames';
import { FlexContainer, ContentBlock, Txt } from 'components';
import Icon from '../Icon';
import styles from './InfoMessageBlock.module.scss';

/**
 * InfoMessageBlock
 *
 * @return {JSX.Element}
 */
const InfoMessageBlock = ({
  className,
  title,
  description,
  icon,
  caption,
  highlight = 'black',
  black,
  captionAsCaption,
  customContentRight,
  ...rest
}) => {
  return (
    <ContentBlock
      className={classNames(
        styles.InfoMessageBlock,
        className,
        `${InfoMessageBlock.displayName}`
      )}
      gap
      alignCenter
      black={black}
      {...rest}
    >
      {icon ? <Icon name={icon} highlight={highlight} /> : null}
      <FlexContainer flex column gapHalf justifyContentCenter>
        {caption ? (
          <Txt regular caption={captionAsCaption} className={styles.Caption}>
            {caption}
          </Txt>
        ) : null}
        {title ? (
          <Txt bold xx>
            {title}
          </Txt>
        ) : null}
        {description ? (
          <Txt regular caption={black}>
            {description}
          </Txt>
        ) : null}
      </FlexContainer>
      {customContentRight ? customContentRight : null}
    </ContentBlock>
  );
};

InfoMessageBlock.displayName = 'InfoMessageBlock';

export default InfoMessageBlock;
